import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import 'rxjs-compat/add/observable/fromEvent';
import { environment } from '../../../environments/environment';

@Injectable()
export class WebWidgetService {
  public iframe;
  public webWidgetUrl;
  public openIframe$ = new Subject<void>();

  constructor() {
    this.webWidgetUrl = environment.WEB_WIDGET_URL;
  }

  listenForEventsInIframe() {
    return Observable.fromEvent(window, 'message');
  }

  sendEventIntoIframe(message) {
    return this.iframe.contentWindow.postMessage(message, '*');
  }

  openDialPadWithNumber(phoneNumber) {
    this.openIframe$.next();
    this.iframe.src = `${this.webWidgetUrl}/#/main/(overlay:dial/${phoneNumber})`;
  }

  openDialPad() {
    this.openIframe$.next();
  }
}
